import { RecordingRTCPool } from "./recording-rtc-pool";
import * as proto from "../protocol/protocol";
import { LoggerService } from "../logger/logger-service";
import { RecordingRTCPoolFactory } from "./recording-rtc-pool-factory";

export class RecordingRTCPoolRepository {
  // tslint:disable-next-line:readonly-keyword
  private recordingRtcPools: { [callId: string]: RecordingRTCPool } = {};

  constructor(
    private loggerService: LoggerService,
    private recordingRtcPoolFactory: RecordingRTCPoolFactory
  ) {}

  public getRecordingRtcPoolInstance(callId: proto.ID): RecordingRTCPool {
    const recordingRtcPool = this.recordingRtcPools[callId];

    if (!recordingRtcPool) {
      this.loggerService.debug(`creating RecordingRTCPool for call ${callId}`);
      this.recordingRtcPools[callId] =
        this.recordingRtcPoolFactory.create(callId);
    }

    return this.recordingRtcPools[callId]!;
  }

  public destroyRecordingRtcPool(callId: proto.ID): void {
    const recordingRtcPool = this.recordingRtcPools[callId];
    if (recordingRtcPool) {
      this.loggerService.debug(
        `destroying RecordingRTCPool for call ${callId}`
      );
      recordingRtcPool.destroyAllConnections();
      delete this.recordingRtcPools[callId];
    }
  }
}
